import type { Option } from '@pulse-web-ui/autocomplete-select';
import { action } from 'mobx';

import type { TypesSelfEmploymentData } from '@features/registration-questionary/api';

export const getTypesSelfEmploymentOptions = action(
  (
    typesSelfEmploymentData: TypesSelfEmploymentData[] | undefined
  ): Option[] | [] => {
    if (!typesSelfEmploymentData) return [];

    return typesSelfEmploymentData.map((item: TypesSelfEmploymentData) => ({
      label: item.name,
      value: item.code,
    }));
  }
);
